export default "__VITE_ASSET__5959fc1b__"